import API from '@/api/purchaseSalesCenter/purchaseSales.js';
import ORDER_API from '@/api/purchaseSalesCenter/purchaseSales.js';
import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
import { filterEmpty } from '@/common/js/util';
import { formatDate } from '@/utils';
import BASE_API from '@/api/dataBase';
import COOPERATION_API from '@/api/masterData/cooperation';
import ProjectApi from '@/api/purchaseSalesCenter/project.js';
export default {
  data() {
    return {
      companyList: [],
      supplierList: [],
      departmentList: [],
      baseFormData: {
        version: null,
        projectInitiationNo: '',
        projectName: '',
        companyCode: '',
        companyName: '',
        contractBusinessDepartment: '',
        contractBusinessDepartmentName: '',
        supplierNo: '',
        supplierName: '',
        contractNo: '',
        contractTotalAmount: '0', // TODO 除了协议以外这个字段必须
        purchaseQuantity: '0',
        signDate: '',
        externalContractNo: '',
        isDefault: '',
        contractCreateDate: '',
        replyInvoiceDate: '',
        companyCurrency: '',
        companyCurrencyName: '',
        liquidatedDamagesType: '',
        liquidatedDamagesName: '',
        liquidatedFixedValue: '',
        liquidatedInterestRate: '',
        contractOperaterNo: '',
        contractOperaterName: '',
        contractSalesmanName: '',
        contractSalesmanNo: '',
        lastestPayMoneyDay: '',
        lastestReceiveProductDay: '',
        businessType: '',
        isPrepay: '',
        creditAmount: '',
        isFixedPrice: null,
        pricingRule: '',
        receiptMethod: '',
        receiptMethodName: '',
        contractValidStart: '',
        contractValidEnd: '',
        isGenerateSales: null,
        contractName: '',
        // customerName: '',
        customerNo: '',
        // recyclingCompanyFileNo: '',
        recyclingCompanyName: '',
        platformCompanyCode: '',
        // platformCompanyFileNo: '',
        platformCompanyName: '',
        overShippedPercentage: '',
        shortShippedPercentage: '',
        mark: '',
        contractCurrency: '',
        contractCurrencyName: '',
        id: null, // 在编辑的时候反填值
        isRelatedParty: '', // 给表格中判断是否内部
        partnerType: '', // 给表格判断是否为投送和外部
        // generateSalesCompanyName: '',
        generateSalesCompanyNo: '',
        generateSalesDepartment: '',
        // generateSalesDepartmentName: '',
        generateNo: '',
        totalQuantity: '0', // 后端新增的,其实和purchaseQuantity一样的
        warrantyClause: '', // 条款
        performanceBondPayMethodCode: '',
        performanceBond: '',
        identityNo: '',
        bankAccount: '',
        bankName: '',
        bankCode: '',
        creditPercent: '',
        isRestrict: '',
        ifPersonalPartner: '',
      },
      // 是否隐藏勾选采购协议
      isHideGenerateSalesField: true,
      // 过滤后字段
      filterFormColumList: [],

      orderContractRelationshipList: [],
      attachments: [],
      orderDetailList: [],
      // 当前单的状态
      contractStatus: null,
      // 全部数据
      detailPageData: null,
      supplierType: '', // 合作伙伴类型
      isShowOverdueInterestTab: false, //是城矿公司且是内部的时候展示
      orderInterest: {},
      isDisabledPricingRule: true,

      companyList1: [], // 回收公司和平台公司
      $filterFormField: null,
      bankList: [], // 银行卡号
      departmentList2: [],
      companyList2: [],
      recyclingCompanyFileList: [], // 回收公司
      platformCompanyFileList: [], // 平台公司
      disabledIsRestrict: false, // 是否禁用是否限购
    };
  },
  methods: {
    async getBankInfo(partnerCode, companyCode) {
      // 获取收票(收款)人对应银行
      if (partnerCode) {
        let res = await this.$axios.get(PAYMENT_API.GET_PARTER_BANK, {
          partnerCode,
          companyCode,
        });
        if (res) {
          if (res.data.code == 0) {
            this.bankList = res.data.data.map((item) => {
              return {
                ...item,
                value: item.bankAccount,
                label: item.bankAccount,
              };
            });
            // if (res.data.data && res.data.data.length == 1) {
            //   let tempData = res.data.data[0];
            //   this.baseData.billTakeBankNo = tempData.associatedLineNumber;
            //   this.baseData.billTakeBankName = tempData.accountBankBranch;
            //   this.baseData.billTakeBankAccount = tempData.bankAccount;
            // }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      }
    },
    // 根据合作伙伴获取具体信息
    async getSupplierInfoApi(partnerCode, companyCode, departmentCode) {
      const { data } = await this.$axios.post(COOPERATION_API.LIST_PARTNEREXTEND, {
        partnerZhName: '',
        partnerCode,
        searchCode: '',
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        pageSize: 10,
        pageNum: 1,
        departmentCode,
        companyCode,
      });
      if (data.code == 0) {
        if (!data?.data?.list?.length) return;
        const { isRelatedParty, partnerType, ifPersonalPartner } = data?.data?.list[0];
        console.log(isRelatedParty, partnerType, ifPersonalPartner, '==哈哈哈=???');
        const supplierType = this._judgeSupplierType(
          isRelatedParty,
          partnerType,
          ifPersonalPartner
        );
        this.baseFormData = {
          ...this.baseFormData,
          isRelatedParty,
          partnerType,
          ifPersonalPartner,
        };
        this.supplierType = supplierType;
        // 配置表单数据
        this._hiddenFormFieldByCompanyCodeAndSupplierCode(
          companyCode,
          supplierType,
          !this.baseFormData.isGenerateSales // 特殊处理，如果是false表示未勾选，其实要隐藏字段
        );
      } else {
        console.error('获取供应商失败');
      }
    },
    // 获取数据
    async getOrderDetail() {
      this.loading.startLoading();
      const isCopy = this.$route.query.isCopy == 'true';
      const postData = {
        contractNo: this.$route.query.contractNo,
        dataGroup: this.$globalVar.dataGroup,
        // copyFlag: this.$route.query.copyFlag,
        // relationContractDetailCategory: this.$route.query.type,
      };
      const copyData = {
        copyFlag: this.$route.query.copyFlag || 0,
        relationContractDetailCategory: this.$route.query.type,
      };
      const { data } = await this.$axios.post(
        ORDER_API.GET_ORDER_DETAIL_API,
        isCopy ? { ...postData, ...copyData } : postData
      );
      this.loading.endLoading();
      if (data.code == 0) {
        // 反填表单数据
        const {
          version,
          projectInitiationNo,
          projectName,
          companyCode,
          companyName,
          contractBusinessDepartment,
          contractBusinessDepartmentName,
          supplierNo,
          supplierName,
          contractNo,
          contractTotalAmount, // TODO 除了协议以外这个字段必须
          purchaseQuantity,
          contractSalesmanName,
          signDate,
          externalContractNo,
          contractSalesmanNo,
          isDefault,
          contractCreateDate,
          replyInvoiceDate,
          companyCurrency,
          companyCurrencyName,
          liquidatedDamagesType,
          liquidatedDamagesName,
          liquidatedFixedValue,
          liquidatedInterestRate,
          contractOperaterNo,
          contractOperaterName,
          lastestPayMoneyDay,
          lastestReceiveProductDay,
          businessType,
          isPrepay,
          creditAmount,
          isFixedPrice,
          pricingRule,
          receiptMethod,
          receiptMethodName,
          contractValidStart,
          contractValidEnd,
          isGenerateSales,
          contractName,
          // customerName,
          customerNo,
          // recyclingCompanyFileNo,
          recyclingCompanyName,
          platformCompanyCode,
          // platformCompanyFileNo,
          platformCompanyName,
          overShippedPercentage,
          shortShippedPercentage,
          mark,
          contractCurrency,
          contractCurrencyName,
          id,
          attachmentList,
          orderContractRelationshipList,

          contractStatus,
          orderInterest,
          departmentCode,
          departmentName,
          warrantyClause,
          performanceBondPayMethodCode,
          performanceBond,
          contractBusinessCompanyName,
          contractBusinessCompanyNo,
          generateNo,
          identityNo,
          bankAccount,
          bankName,
          bankCode,
          creditPercent,
          // generateSalesCompanyName,
          generateSalesCompanyNo,
          generateSalesDepartment,
          // generateSalesDepartmentName,
          orderDetailList,
          isRestrict,
          ifPersonalPartner,
          requestId,
        } = data.data;
        this._getDepartmentByCompanyCodeApi(companyCode);
        this.orderDetailList = orderDetailList ? orderDetailList : []; // 产品明细
        this.orderContractRelationshipList = orderContractRelationshipList
          ? orderContractRelationshipList
          : []; // 关联明细
        this.attachments = attachmentList ? attachmentList : []; // 附件
        this.contractStatus = contractStatus; // 当前单的状态
        this.detailPageData = data.data; // 全部数据
        this.orderInterest = orderInterest ? orderInterest : {}; //逾期
        // 禁用
        const disableList = this._formItemIsDisabledByContractStatus(); // 禁用表单
        // 编辑模式根据判断来禁止,极端状态空数组表示全部禁止
        if (disableList) {
          if (disableList.length == 0) {
            this.isDisabledForm = true; // 全部禁止
          } else {
            this.disabledFieldList = disableList; // 部分禁止
          }
        }
        console.log(departmentCode, departmentName, '========================>');
        // 根据供货商获取银行数据
        this.getBankInfo(supplierNo, companyCode);
        // 表单
        const formData = {
          version,
          projectInitiationNo,
          projectName,
          generateNo,
          contractBusinessDepartment,
          contractBusinessDepartmentName,
          supplierNo,
          supplierName,
          contractNo,
          contractTotalAmount: this.replaceZeroStr(contractTotalAmount), // TODO 除了协议以外这个字段必须
          purchaseQuantity: this.replaceLastZeroStr(purchaseQuantity),
          contractSalesmanName,
          signDate,
          externalContractNo,
          contractSalesmanNo,
          isDefault,
          contractCreateDate,
          replyInvoiceDate,
          companyCurrency,
          companyCurrencyName,
          liquidatedDamagesType,
          liquidatedDamagesName,
          liquidatedFixedValue,
          liquidatedInterestRate,
          contractOperaterNo,
          contractOperaterName,
          lastestPayMoneyDay,
          lastestReceiveProductDay,
          businessType,
          isPrepay: isPrepay ? true : false,
          creditAmount,
          isFixedPrice: isFixedPrice == 1 ? true : false,
          pricingRule,
          receiptMethod,
          receiptMethodName,
          contractValidStart,
          contractValidEnd,
          contractName,
          // customerName,
          customerNo,
          // recyclingCompanyFileNo,
          recyclingCompanyName,
          platformCompanyCode,
          // platformCompanyFileNo,
          platformCompanyName,
          overShippedPercentage,
          shortShippedPercentage,
          mark,
          contractCurrency,
          contractCurrencyName,
          isGenerateSales,
          id,
          departmentName: departmentName ? departmentName : contractBusinessDepartmentName,
          departmentCode: departmentCode ? departmentCode : contractBusinessDepartment,
          // generateSalesCompanyName,
          generateSalesCompanyNo,
          generateSalesDepartment,
          // generateSalesDepartmentName,
          warrantyClause,
          performanceBondPayMethodCode,
          performanceBond,
          companyCode: companyCode ? companyCode : contractBusinessCompanyNo,
          companyName: companyName ? companyName : contractBusinessCompanyName,
          identityNo,
          bankAccount,
          bankName,
          bankCode,
          creditPercent,
          isRestrict,
          ifPersonalPartner,
          requestId,
        };
        let newFormData = {};
        for (const key in formData) {
          if (typeof formData[key] == 'number') {
            newFormData[key] = formData[key] + '';
          } else {
            newFormData[key] = formData[key];
          }
        }
        this.baseFormData = {
          ...this.baseFormData,
          ...newFormData,
        };
        // 处理好定价模式是否可以编辑
        this.isDisabledPricingRule = isFixedPrice == 1 ? false : true;
        // 获取当前供应商信息
        await this.getSupplierInfoApi(supplierNo, companyCode, departmentCode);
        // 根据项目projectInitiationNo来查下平台公司和回收公司列表
        await this.getProjectByProjectNo(projectInitiationNo);
      } else {
        this.$message.error(data.msg);
      }
    },
    async getProjectByProjectNo(projectInitiationNo) {
      const { data } = await this.$axios.post(ProjectApi.PROJECT_LIST1, { projectInitiationNo });
      if (data.code == 0) {
        const rowData = data.data[0];
        const platformtCompany = rowData.platformtCompany;
        const platformtCompanyName = rowData.platformtCompanyName;
        const recyclingtCompany = rowData.recyclingtCompany;
        const recyclingtCompanyName = rowData.recyclingtCompanyName;
        this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
        this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
      } else {
        console.error('根据项目号获取项目信息失败');
      }
    },
    // 获取公司
    async _getCompanyApi() {
      this.loading.startLoading();
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      this.loading.endLoading();
      if (data.code == 0) {
        this.companyList = data.data?.personCompanyInfo;
        // 初始化表单字段
        this._hiddenFormFieldByCompanyCodeAndSupplierCode(
          this.userInfo.companyCode,
          this.supplierType
        );
        // 默认初始化全部表单数据
        if (this.baseFormData.companyCode) {
          // 获取部门下拉
          this._getDepartmentByCompanyCodeApi(this.baseFormData.companyCode);
        }
      } else {
        console.error('获取公司失败');
      }
    },
    // 回收公司和平台公司
    async _getCompanyApi1() {
      const { data } = await this.$axios.get(
        `${BASE_API.LISTDATA_SERECHCOMPANY}/${this.userInfo.tenantCode}`
      );
      if (data.code == 0) {
        this.companyList1 = data.data;
      } else {
        console.error('获取公司失败');
      }
    },
    async _getCompanyApi2() {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        this.companyList2 = data.data?.personCompanyInfo.map((item) => {
          return {
            label: item.personCompanyName,
            value: item.personCompanyCode,
          };
        });
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode) {
      if (companyCode) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          this.departmentList = data.data?.personDepartmentInfo.map((item) => {
            return {
              label: item.personDepartmentName,
              value: item.personDepartmentCode,
            };
          });
        } else {
          console.error('获取部门失败');
        }
      }
    },
    async _getDepartmentByCompanyCodeApi2(companyCode) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        this.departmentList2 = data.data?.personDepartmentInfo.map((item) => {
          return {
            label: item.personDepartmentName,
            value: item.personDepartmentCode,
            oaId: item.oaId,
          };
        });
      } else {
        console.error('获取部门失败');
      }
    },
    // 判断当前供应商是内部、外部、投送人
    /**
     * @param {*} isRelatedParty 是否为关联方
     * @param {*} partnerType 供应商
     * @param {*} ifPersonalPartner  是否是个人合作伙伴
     * @returns
     */
    _judgeSupplierType(isRelatedParty, partnerType, ifPersonalPartner) {
      console.log(
        `判断当前供应商类型表格中===>>>是否关联方:${isRelatedParty},供应商:${partnerType}, 是否个人合作伙伴:${ifPersonalPartner}`
      );
      // 内部
      if (isRelatedParty == 'Y') {
        return 'INTERNAL_SETTLEMENT';
      }
      if (partnerType == 'HZHB02' && ifPersonalPartner == '1' && isRelatedParty == 'N') {
        // 投送人
        return 'DROP_OFF_PERSON';
      }
      // 外部
      return 'WITHOUT_SETTLEMENT';
    },
    // 切割回收公司
    splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName) {
      if (recyclingtCompany && recyclingtCompanyName) {
        const recyclingtCompanyList = recyclingtCompany.split(',');
        const recyclingtCompanyNameList = recyclingtCompanyName.split(',');
        this.recyclingCompanyFileList = recyclingtCompanyList.map((item, index) => {
          return {
            label: recyclingtCompanyNameList[index],
            value: item,
          };
        });
      } else {
        this.recyclingCompanyFileList = [];
      }
    },
    // 切割平台公司
    splitPlatformtCompanyList(platformtCompany, platformtCompanyName) {
      if (platformtCompany && platformtCompanyName) {
        const platformtCompanyList = platformtCompany.split(',');
        const platformtCompanyNameList = platformtCompanyName.split(',');
        this.platformCompanyFileList = platformtCompanyList.map((item, index) => {
          return {
            label: platformtCompanyNameList[index],
            value: item,
          };
        });
      } else {
        this.platformCompanyFileList = [];
      }
    },
    changeMethod({ prop, val }) {
      console.log(prop, val, '切换选择');

      // 修改供应商是否禁用开启协议
      if (prop == 'supplierNo') {
        const {
          partnerCode,
          partnerZhName,
          // departmentName,
          // departmentCode,
          isRelatedParty,
          ifPersonalPartner,
          partnerType,
          identityNo,
        } = val[0];
        console.log(
          partnerCode,
          partnerZhName,
          isRelatedParty,
          partnerType,
          '供应商',
          this.baseFormData.companyCode
        );
        this.baseFormData = {
          ...this.baseFormData,
          isGenerateSales: isRelatedParty == 'Y' ? true : false,
          supplierNo: partnerCode,
          supplierName: partnerZhName,
          // generateSalesCompanyName: partnerZhName,
          // generateSalesCompanyNo: companyCode,
          identityNo,
          isRelatedParty,
          partnerType,
          ifPersonalPartner,
          bankAccount: '',
          bankName: '',
          bankCode: '',
        };
        console.log(this.baseFormData.isRelatedParty, this.baseFormData.isGenerateSales);
        // TODO 根据选择的供应商来判断
        // 1.合作伙伴主数据那边是否为关联方，isRelatedParty是的时候就是内部，否的时候是外部和投送，走下面继续判断
        // 2.否的时候根据合作伙伴主数据判断合作伙伴类型 partnerType==HZHB13 表示投送人，别的都是外部
        // 切换供货商的时候处理表单字段
        const supplierType = this._judgeSupplierType(
          isRelatedParty,
          partnerType,
          ifPersonalPartner
        );
        this.supplierType = supplierType;
        // 切换供应商的时候更新表单表单
        this._hiddenFormFieldByCompanyCodeAndSupplierCode(
          this.baseFormData.companyCode,
          supplierType
        );
        // 重置表格数据
        this.$refs.orderDetailListRef?.resetTable();
        this.baseFormData.contractTotalAmount = '';
        // 根据供货商获取银行数据
        this.getBankInfo(partnerCode, this.baseFormData.companyCode);
      } else if (prop == 'companyCode') {
        // 选择公司
        const currentItem = this.companyList.find((item) => item.personCompanyCode == val);
        this.baseFormData = {
          ...this.baseFormData,
          departmentCode: '',
          departmentName: '',
          supplierNo: '',
          supplierName: '',
          companyCode: val,
          companyName: currentItem?.personCompanyName,
          isGenerateSales: false,
        };
        if (val) {
          this._getDepartmentByCompanyCodeApi(val);
        }
        // 重置表格数据
        this.$refs.orderDetailListRef?.resetTable();
        this.baseFormData.contractTotalAmount = '';
      } else if (prop === 'departmentCode') {
        // 选择部门的时候
        const currentItem = this.departmentList.find((item) => item.value == val);
        this.baseFormData = {
          ...this.baseFormData,
          departmentCode: val,
          departmentName: currentItem?.label,
        };
        // this.baseFormData.contractBusinessDepartment = val;
        // this.baseFormData.contractBusinessDepartmentName = currentItem?.personDepartmentName;
        console.log('选择部门', this.baseFormData);
      } else if (prop == 'contractSalesmanNo') {
        // 业务员
        let rowData = val[0];
        this.baseFormData = {
          ...this.baseFormData,
          contractSalesmanNo: rowData?.id,
          contractSalesmanName: rowData?.personName,
          // 手动添加
          personChargeName: rowData?.personName,
          personChargeCode: rowData?.id,
        };
        console.log(this.baseFormData.contractSalesmanName, this.baseFormData.contractSalesmanNo);
      } else if (prop == 'companyCurrency') {
        // 币种
        this.baseFormData = {
          ...this.baseFormData,
          companyCurrency: val?.currencyCode,
          companyCurrencyName: val?.currencyName,
          contractCurrency: val?.currencyCode,
          contractCurrencyName: val?.currencyName,
        };
      } else if (prop == 'contractOperaterNo') {
        // 操作人
        // this.baseFormData = {
        //   ...this.baseFormData,
        //   contractOperaterNo: '',
        //   contractOperaterName: '',
        // };
      } else if (prop == 'isGenerateSales') {
        // 是否生成销售协议
        console.log('点击了是否生成销售协议/合同', val);
        if (val) {
          this.baseFormData = {
            ...this.baseFormData,
            isGenerateSales: true,
          };
          this._hiddenFormFieldByCompanyCodeAndSupplierCode(
            this.baseFormData.companyCode,
            this.supplierType,
            false
          );
        } else if (!val) {
          this.baseFormData = {
            ...this.baseFormData,
            isGenerateSales: false,
          };
          this._hiddenFormFieldByCompanyCodeAndSupplierCode(
            this.baseFormData.companyCode,
            this.supplierType,
            true
          );
        }
      } else if (prop == 'projectInitiationNo') {
        // 项目编号
        const rowData = val[0];
        this.baseFormData = {
          ...this.baseFormData,
          projectInitiationNo: rowData?.projectInitiationNo,
          projectName: rowData?.projectAbbreviation,
          // recyclingCompanyFileNo: '',
          recyclingCompanyName: '',
          platformCompanyCode: '',
          // platformCompanyFileNo: '',
          platformCompanyName: '',
        };
        console.log('修改项目');
        if (rowData) {
          const recyclingtCompany = rowData?.recyclingtCompany;
          const recyclingtCompanyName = rowData?.recyclingtCompanyName;
          const platformtCompany = rowData?.platformtCompany;
          const platformtCompanyName = rowData?.platformtCompanyName;
          this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
          this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
        }
      } else if (prop == 'isPrepay') {
        if (!val) {
          this.baseFormData = {
            ...this.baseFormData,
            creditAmount: '',
          };
        }
      } else if (prop == 'recyclingCompanyFileNo') {
        // 回收公司
        // this.baseFormData.recyclingCompanyFileNo = val;
        // const item = this.recyclingCompanyFileList.find((item) => item.value == val);
        // this.baseFormData.recyclingCompanyName = item?.label;
      } else if (prop == 'platformCompanyFileNo') {
        // this.baseFormData.platformCompanyFileNo = val;
        // const item = this.platformCompanyFileList.find((item) => item.value == val);
        // this.baseFormData.platformCompanyName = item?.label;
      } else if (prop == 'bankAccount') {
        const currentItem = this.bankList.find((item) => item.bankAccount == val);
        console.log(currentItem, '=====??', val, this.bankList);
        this.baseFormData.bankAccount = currentItem.bankAccount;
        this.baseFormData.bankName = currentItem.bankName;
        this.baseFormData.bankCode = currentItem.bankCode;
      } else if (prop == 'generateSalesCompanyName') {
        // const currentItem = this.companyList2.find((item) => item.value == val);
        // console.log(currentItem, val);
        // this.baseFormData.generateSalesCompanyNo = val;
        // this.baseFormData.generateSalesCompanyName = currentItem.label;
        // this.baseFormData.generateSalesDepartment = '';
        // this.baseFormData.generateSalesDepartmentName = '';
        // this._getDepartmentByCompanyCodeApi2(val);
      } else if (prop == 'generateSalesDepartmentName') {
        // const currentItem = this.departmentList2.find((item) => item.value == val);
        // this.baseFormData.generateSalesDepartment = val;
        // this.baseFormData.generateSalesDepartmentName = currentItem.label;
      } else if (prop == 'receiptMethod') {
        const item = this.dictListMap?.receipt_method.find((item) => item.value == val);
        this.baseFormData.receiptMethod = val;
        this.baseFormData.receiptMethodName = item?.label;
      }
    },
    // 按钮组事件
    btnGroupHandler(clickName, params) {
      this[clickName](params);
    },
    // 撤回审批
    withdrawApprovalHandler() {
      this.loading.startLoading();
      this.$axios
        .post('/sales/order/batchAuditWithdrawOA', {
          contractNos: [this.$route.query.contractNo],
          requestIds: [this.baseFormData?.requestId ?? ''],
          contractCategory: 'purchase',
          oaId: this.userInfo.oaId,
        })
        .then((res) => {
          console.log(res);
          this.loading.endLoading();
          const { code, msg } = res.data;
          if (code == 0) {
            this.$message.success('撤回成功');
            this.closeCurrentAndToList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
    // 打印
    printHandler() {
      console.log('点击打印', this.$route.query.contractNo);
      this.$axios
        .post(API.EXPORT_PRINT_API, { contractNos: [this.$route.query.contractNo] })
        .then((res) => {
          const {
            data: { code, data },
          } = res;
          if (code == 0) {
            window.location.href = data.attachmentPath;
          } else {
            this.$message.error('打印失败');
          }
        });
    },
    //保存和提交 0是保存,1是提交
    async handleSave(type) {
      this.$refs.formItem.validate(async (valid, formData) => {
        if (valid) {
          console.log(formData, '--表单数据->>');
          // 如果当前状态为contractStatus=ZT061的时候提示下
          if (this.detailPageData?.contractStatus == 'ZT061' && this.detailPageData?.generateNo) {
            this.$message.success(`请同步修改已关联的销售合同号${this.detailPageData.generateNo}`);
          }
          const extendData = {
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            companyName: this.userInfo.companyName,
            companyCode: this.userInfo.companyCode,
          };
          const isCopy = this.$route.query.isCopy == 'true';
          const isNew = this.$route.query.isNew == 'true';
          // console.log(this.$refs.upload.)
          const orderContractRelationshipList = this.$refs.relationInfo
            .getTableData()
            .map((item) => {
              return {
                ...item,
                id: isCopy ? '' : item.id,
                ...extendData,
              };
            }); // 关联明细
          const { orderDetailList, orderDetailDelIds } =
            await this.$refs.orderDetailListRef?.getValidateTableData(); // 产品明细
          console.log(orderDetailList, '===>数据');

          if (!orderDetailList.length) return;
          const attachmentList = this.$refs.fileTableRef?.getTableData().map((item) => {
            return {
              ...item,
              id: isCopy ? '' : item.id,
              ...extendData,
            };
          }); // 附件
          let orderInterest = {}; //逾期利息
          if (this.isShowOverdueInterestTab) {
            const orderInterestData = await this.$refs.overdueInterestRef.validate();
            if (orderInterestData.isOverDueInterest) {
              orderInterest = { ...orderInterestData, ...extendData };
            }
          }
          // this.$refs.calculationInterest
          console.log(attachmentList, '附件');
          // 开票要求
          const remark = this.remark && this.remark.remark; // 开票申请
          const businessContractUnitPrice = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractUnitPrice,
            0
          );
          const businessContractTotalAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractTotalAmount,
            0
          );
          const businessContractTaxAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractTaxAmount,
            0
          );
          const businessContractPureAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractPureAmount,
            0
          );
          const businessChangeUnitPrice = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangeUnitPrice,
            0
          );
          const businessChangeTotalAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangeTotalAmount,
            0
          );
          const businessChangeTaxAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangeTaxAmount,
            0
          );
          const businessChangePureAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangePureAmount,
            0
          );
          console.log(formData);
          const contractBusinessCompanyName = formData?.companyName ? formData?.companyName : null;
          const contractBusinessCompanyNo = formData?.companyCode ? formData?.companyCode : null;
          const contractBusinessDepartment = formData?.departmentCode
            ? formData.departmentCode
            : null;

          const contractBusinessDepartmentName = formData?.departmentName
            ? formData.departmentName
            : null;
          // 重新计算 采购数量 和合同总金额
          // const contractTotalAmount = orderDetailList.reduce(
          //   (cur, next) => cur + +next.businessContractTotalAmount,
          //   0
          // );
          const contractTotalAmount = formData.contractTotalAmount;

          const purchaseQuantity = orderDetailList.reduce(
            (cur, next) => cur + +next.productQuantity,
            0
          );
          console.log(this.hiddenList.includes('isFixedPrice'), '----哈哈');
          const isFixedPrice = this.hiddenList.includes('isFixedPrice')
            ? null
            : formData.isFixedPrice
            ? '1'
            : '0';
          console.log(isFixedPrice);
          let postData = {
            ...filterEmpty(formData),
            contractTotalAmount: contractTotalAmount + '' == 'NaN' ? 0 : contractTotalAmount, // 重新计算金额
            purchaseQuantity:
              purchaseQuantity + '' == 'NaN' ? 0 : Number(purchaseQuantity).toFixed(6), // 重新计算采购数量
            contractStatus: this.contractStatus, // 根据条件来判断传递的值
            // 合同签署日
            signDate: formData.signDate ? `${formData.signDate}` : null,
            contractSalesmanNo: formData?.contractSalesmanNo,
            contractSalesmanName: formData?.contractSalesmanName,
            isRestrict: +formData?.isRestrict,
            // 手动添加
            personChargeName: formData?.contractSalesmanName,
            personChargeCode: formData?.contractSalesmanNo,
            contractCreateDate: formData?.contractCreateDate
              ? formatDate(formData?.contractCreateDate, false)
              : null,
            contractBusinessDepartment,
            contractBusinessDepartmentName,
            contractBusinessCompanyName,
            contractBusinessCompanyNo,
            contractDetailCategory: this.$route.query.type,
            tenantCode: this.userInfo.tenantCode,
            orderInterest, // 逾期利息

            isGenerateSales: formData?.isGenerateSales ? true : false,
            isPrepay: formData?.isPrepay ? 1 : 0,
            // 是否定价
            isFixedPrice,
            contractCategory: 'purchase', // 代表销售还是合同
            orderContractRelationshipList,
            businessChangeTotalAmount,
            productQuantity: formData.purchaseQuantity, // 商品数量
            lastestReceiveProductDay: formData.lastestReceiveProductDay
              ? formData.lastestReceiveProductDay
              : null,
            lastestPayMoneyDay: formData.lastestPayMoneyDay ? formData.lastestPayMoneyDay : null,
            lastestSendProductDay: formData.lastestSendProductDay
              ? formData.lastestSendProductDay
              : null,
            orderDetailList: orderDetailList.map((item) => {
              return {
                ...item,
                id: isCopy ? '' : item.id,
                ...extendData,
              };
            }),
            orderDetailDelIds, // 删除在id
            attachmentList,
            remark,
            type,
            id: isCopy ? '' : formData?.id,
            requestId: formData?.requestId ?? '',
            // 新增字段根据表格来合计
            businessContractUnitPrice: businessContractUnitPrice ? businessContractUnitPrice : 0,
            // businessContractUnitPriceLocal: '0',
            businessContractTotalAmount: businessContractTotalAmount
              ? Number(businessContractTotalAmount).toFixed(6)
              : 0,
            // businessContractTotalAmountLocal: 210,
            businessContractTaxAmount: businessContractTaxAmount
              ? Number(businessContractTaxAmount).toFixed(6)
              : 0,
            // businessContractTaxAmountLocal: 23.84,
            businessContractPureAmount: businessContractPureAmount
              ? Number(businessContractPureAmount).toFixed(6)
              : 0,
            // businessContractPureAmountLocal: 187.16,
            businessChangeUnitPrice: businessChangeUnitPrice
              ? Number(businessChangeUnitPrice).toFixed(6)
              : 0,
            // businessChangeTotalAmountLocal: 210,
            businessChangeTaxAmount: businessChangeTaxAmount
              ? Number(businessChangeTaxAmount).toFixed(6)
              : 0,
            // businessChangeTaxAmountLocal: 23.84,
            businessChangePureAmount: businessChangePureAmount
              ? Number(businessChangePureAmount).toFixed(6)
              : 0,
            // businessChangePureAmountLocal: 186.16,
            oaId: this.userInfo.oaId, // 走oa审批
          };
          console.log(postData, '---->');
          if (this.$route.query.type == 'CG02') {
            delete postData.isRestrict;
          }

          if (postData.isGenerateSales == true) {
            if (postData.generateSalesDepartment && postData.generateSalesDepartment.length != 0) {
              let item = this.departmentList2.find(
                (item) => item.value == postData.generateSalesDepartment
              );
              if (item && item.oaId) {
                postData.generateOaId = item.oaId;
              }
            }
          }
          // if (COMPANY_CODE1.includes(this.baseFormData.companyCode)) {
          //   postData.isFixedPrice = null;
          // }
          // 如果主表没有数据,子表有的时候
          if (this.hiddenList.includes('isFixedPrice')) {
            // 处理采购协议
            const isFixedPriceList = orderDetailList
              .map((item) => item.isFixedPrice)
              .filter((item) => item == 0 || item == 1);
            console.log(isFixedPriceList, '----------------------------');
            if (isFixedPriceList.length) {
              postData.isFixedPrice = isFixedPriceList.includes(0) ? 1 : 0;
            } else {
              postData.isFixedPrice = null;
            }
          }

          // 针对拷贝的时候特殊处理
          const copyPostData = {
            copyFlag: this.$route.query.copy ? '0' : '1',
            relationContractDetailCategory: this.$route.query.type, // 协议CG02 合同CG01
          };
          this.loading.startLoading();
          const { data } = await this.$axios.post(
            ORDER_API.SAVE_ORDER_API,
            isCopy && !isNew ? { ...postData, ...copyPostData } : postData
          );
          this.loading.endLoading();
          if (data.code == 0) {
            this.$message.success(data.msg);
            this.closeCurrentAndToList();
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('请检查填写数据');
        }
      });
    },
    // 复制事件
    copyBtnHandler() {
      const path = {
        path: '/salePurchase/purchaseAgreementCreation',
        name: 'purchaseAgreementCreation',
        meta: {
          keepAlive: false,
          title: '创建采购协议',
        },
        query: {
          type: this.$route.query.type,
          isEdit: 'false',
          isCopy: 'true',
          contractNo: this.$route.query.contractNo,
          dataGroup: this.$globalVar.dataGroup,
          copyFlag: '0',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 创建合同
    createContractBtnHandler() {
      const path = {
        path: '/salePurchase/purchaseContractCreation',
        name: 'purchaseContractCreation',
        meta: {
          keepAlive: false,
          title: '创建采购合同',
        },
        query: {
          type: 'CG01',
          isEdit: 'false',
          isCopy: 'true',
          isNew: 'true',
          contractNo: this.$route.query.contractNo,
          dataGroup: this.$globalVar.dataGroup,
          contractCategory: 'purchase', // 合同总类
          copyFlag: '1',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 删除
    deleteBtnHandler() {
      // const isGenerateSales = this.detailPageData.isGenerateSales;
      const { generateOrderStatus, generateNo, contractStatus, generateOrderStatusCode } =
        this.detailPageData;
      if (
        contractStatus == 'ZT05' &&
        generateOrderStatusCode &&
        generateOrderStatusCode != 'ZT05'
      ) {
        this.$message.error(`关联合同号${generateNo}状态为${generateOrderStatus},且不可删除`);
        return;
      }
      // const generateNo = this.detailPageData.generateNo;
      const message = generateNo ? `同时删除关联合同号${generateNo}` : '确定要删除?';
      this.$confirm(message, '删除提示', {})
        .then(async () => {
          this.loading.startLoading();
          const res = await this.$axios.post(ORDER_API.DELETE_ORDER_API, {
            ids: [this.$route.query.id],
            contractNos: [this.$route.query.contractNo],
            oaId: this.userInfo.oaId,
          });
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            // 关闭
            this.closeCurrentAndToList();
            // this.$router.push({ path: '/salePurchase/purchaseOverview' });
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    //上传回调
    handleUpload(uploadTableData) {
      this.attachments = uploadTableData;
    },
    closeCurrentAndToList() {
      console.log(this.$route.query.type, 'this.$route.query.type');
      const isEdit = this.$route.query.isEdit;
      const type = this.$route.query.type;
      let path = '';
      let name = '';
      if (type == 'CG02') {
        // 协议
        if (isEdit == 'true') {
          path = '/salePurchase/purchaseAgreementEdit';
          name = 'purchaseAgreementEdit';
        } else {
          path = '/salePurchase/purchaseAgreementCreation';
          name = 'purchaseAgreementCreation';
        }
      } else {
        // 合同
        if (isEdit == 'true') {
          path = '/salePurchase/purchaseContractEdit';
          name = 'purchaseContractEdit';
        } else {
          path = '/salePurchase/purchaseContractCreation';
          name = 'purchaseContractCreation';
        }
      }
      // 关闭当前tab导航 , 协议CG02 合同CG01
      this.$store.dispatch('tagsView/delView', {
        path,
        name,
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
      this.$router.push({ path: '/salePurchase/purchaseOverview' });
    },
    // 跳转到供货商发货指令
    goSupplierInstructLink() {
      const path = {
        path: '/wareHouse/addSupplierDelivery',
        name: 'addSupplierDelivery',
        meta: {
          keepAlive: false,
          title: '供货商发货指令维护',
        },
        query: {
          // type: this.$route.query.code,
          // isEdit: true,
          // isCopy: true,
          // dataGroup: this.$globalVar.dataGroup,
          contractNo: this.$route.query.contractNo,
          contractDetailNoList: this.detailPageData?.contractDetailNoList,
          // businessChangeUnitPrice,
          businessContractUnitPrice: this.detailPageData?.businessContractUnitPrice,
          financeContractTaxAmount: this.detailPageData?.businessContractTaxAmount,
          financeContractPureAmount: this.detailPageData?.businessContractPureAmount,
          businessContractTotalAmount: this.detailPageData?.businessContractTotalAmount,
          productQuantity: this.detailPageData?.productQuantity,
          isRestrict: this.detailPageData.isRestrict, // 是否定量
          // taxRate=0.11
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 关闭、激活、撤销
    updateStatusHandler(type) {
      const { generateNo } = this.detailPageData;
      // if (type == 2 && generateNo && generateOrderStatusCode == 'ZT03') {
      //   this.$message({
      //     message: `关联合同号${generateNo}状态为${generateOrderStatus}`,
      //     type: 'error',
      //   });
      //   return;
      // }

      const message =
        type == 2 && generateNo ? `同时撤回关联合同号${generateNo}` : '确定要更改合同状态';
      this.$confirm(message, '确认更改状态', {})
        .then(async () => {
          this.loading.startLoading();
          //0-关闭 1-激活 2-撤销
          let postData = {
            id: this.$route.query.id,
            operateFlag: type,
            oaId: this.userInfo.oaId,
          };
          const res = await this.$axios.post(ORDER_API.UPDATE_OTDER_STATUS, postData);
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$router.push({ path: '/salePurchase/purchaseOverview' });
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 确认撤销和驳回撤销
    async confirmCancelHandler(params) {
      // 确认是1，驳回是0
      const postData = {
        id: this.$route.query.id,
        approvaResult: params,
        oaId: this.userInfo.oaId,
      };
      const res = await this.$axios.post(ORDER_API.POST_REVERT_API, postData);
      if (res.data.code == 0) {
        this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'success',
        });
        if (params == 0) {
          // 重新拉数据
          this.getOrderDetail();
        } else {
          this.$router.push({ path: '/salePurchase/purchaseOverview' });
        }

        // //确认撤销后，刷新页面可编辑
        // if (type == 1) {
        //   let query = this.$router.history.current.query;
        //   let path = this.$router.history.current.path;
        //   //对象的拷贝
        //   let newQuery = JSON.parse(JSON.stringify(query));
        //   newQuery.isEdit = false;
        //   this.$router.push({ path, query: newQuery });
        // }
        // this.getOrderDetail();
      } else {
        this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'error',
        });
      }
    },

    // 初始化数据
    _initFormData() {
      if (this.isCreateStatus) {
        console.log('初始化表单数据----');
        if (this.fileType != 'agreement') {
          this.baseFormData.isRestrict = '0';
        }
        this.baseFormData = {
          ...this.baseFormData,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          contractOperaterNo: this.userInfo.userCode,
          contractOperaterName: this.userInfo.personName,
          contractCreateDate: formatDate(new Date()),
          companyCurrency: 'CNY',
          companyCurrencyName: '中国人民币（国际）',
          contractCurrency: 'CNY',
          contractCurrencyName: '中国人民币（国际）',
        };
      }
    },
    // 关闭表格的时候更新表单中总金额
    closeTableHandler(tableData = []) {
      console.log(tableData, '关闭表格统计金额');
      const businessContractTotalAmount = tableData.reduce(
        (cur, next) => cur + +next.businessContractTotalAmount,
        0
      );

      // 处理定价
      const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == 0);
      // this.baseFormData.isFixedPrice = isFixedPriceResult;
      this.isDisabledPricingRule = !isFixedPriceResult;
      // 采购数量回填
      const total = tableData.reduce((cur, next) => cur + +next.productQuantity, 0);
      this.baseFormData = {
        ...this.baseFormData,
        contractTotalAmount:
          businessContractTotalAmount + '' == 'NaN'
            ? 0
            : this.replaceZeroStr(businessContractTotalAmount),
        isFixedPrice: isFixedPriceResult,
        purchaseQuantity: total + '' == 'NaN' ? 0 : this.replaceLastZeroStr(total) + '',
        totalQuantity: total + '' == 'NaN' ? 0 : total + '',
      };
    },
  },
  mounted() {
    if (this.$route.query.contractNo) {
      //获取详情
      this.getOrderDetail();
    }
    this._initFormData();
    this.$nextTick(() => {
      this._getCompanyApi(true);
      this._getCompanyApi1();
      this._getCompanyApi2();
    });
  },
};
